import { AixAction } from '../aix-action';
import { ErrorWrapper } from '../models/common';
import { type } from '../models/type-cache';
import {
    CustomTemplate,
    CustomTemplateBody,
    CustomTemplateCreate,
    CustomTemplateUpdate
} from './model';

export class CustomTemplatesActionTypes {
    // Load Templates
    static readonly LOAD_CUSTOM_TEMPLATES = type('[CustomTemplates] Load Custom Templates');
    static readonly LOAD_CUSTOM_TEMPLATES_SUCCESS = type(
        '[CustomTemplates] Load Custom Templates Success'
    );
    static readonly LOAD_CUSTOM_TEMPLATES_FAILURE = type(
        '[CustomTemplates] Load Custom Templates Failure'
    );

    // Load Template
    static readonly LOAD_CUSTOM_TEMPLATE = type('[CustomTemplates] Load Custom Template');
    static readonly LOAD_CUSTOM_TEMPLATE_SUCCESS = type(
        '[CustomTemplates] Load Custom Template Success'
    );
    static readonly LOAD_CUSTOM_TEMPLATE_FAILURE = type(
        '[CustomTemplates] Load Custom Template Failure'
    );

    // Create Template
    static readonly CREATE_CUSTOM_TEMPLATE = type('[CustomTemplates] Create Custom Template');
    static readonly CREATE_CUSTOM_TEMPLATE_SUCCESS = type(
        '[CustomTemplates] Create Custom Template Success'
    );
    static readonly CREATE_CUSTOM_TEMPLATE_FAILURE = type(
        '[CustomTemplates] Create Custom Template Failure'
    );

    // Update Template
    static readonly UPDATE_CUSTOM_TEMPLATE = type('[CustomTemplates] Update Custom Template');
    static readonly UPDATE_CUSTOM_TEMPLATE_SUCCESS = type(
        '[CustomTemplates] Update Custom Template Success'
    );
    static readonly UPDATE_CUSTOM_TEMPLATE_FAILURE = type(
        '[CustomTemplates] Update Custom Template Failure'
    );

    // Delete Template
    static readonly DELETE_CUSTOM_TEMPLATE = type('[CustomTemplates] Delete Custom Template');
    static readonly DELETE_CUSTOM_TEMPLATE_SUCCESS = type(
        '[CustomTemplates] Delete Custom Template Success'
    );
    static readonly DELETE_CUSTOM_TEMPLATE_FAILURE = type(
        '[CustomTemplates] Delete Custom Template Failure'
    );
}

export type CustomTemplatesActions =
    | LoadCustomTemplatesAction
    | LoadCustomTemplatesSuccessAction
    | LoadCustomTemplatesFailureAction
    | LoadCustomTemplateAction
    | LoadCustomTemplateSuccessAction
    | LoadCustomTemplateFailureAction
    | CreateCustomTemplateAction
    | CreateCustomTemplateSuccessAction
    | CreateCustomTemplateFailureAction
    | UpdateCustomTemplateAction
    | UpdateCustomTemplateSuccessAction
    | UpdateCustomTemplateFailureAction
    | DeleteCustomTemplateAction
    | DeleteCustomTemplateSuccessAction
    | DeleteCustomTemplateFailureAction;

// Load Custom Templates
export class LoadCustomTemplatesAction implements AixAction {
    readonly type = CustomTemplatesActionTypes.LOAD_CUSTOM_TEMPLATES;

    constructor(public payload: { type: 'PPM' | 'ESign' }) {}
}
export class LoadCustomTemplatesSuccessAction implements AixAction {
    readonly type = CustomTemplatesActionTypes.LOAD_CUSTOM_TEMPLATES_SUCCESS;

    constructor(public payload: CustomTemplate[]) {}
}
export class LoadCustomTemplatesFailureAction implements AixAction {
    readonly type = CustomTemplatesActionTypes.LOAD_CUSTOM_TEMPLATES_FAILURE;

    constructor(public payload: ErrorWrapper) {}
}

// Load Custom Template
export class LoadCustomTemplateAction implements AixAction {
    readonly type = CustomTemplatesActionTypes.LOAD_CUSTOM_TEMPLATE;

    constructor(public payload: number) {}
}
export class LoadCustomTemplateSuccessAction implements AixAction {
    readonly type = CustomTemplatesActionTypes.LOAD_CUSTOM_TEMPLATE_SUCCESS;

    constructor(public payload: CustomTemplate) {}
}
export class LoadCustomTemplateFailureAction implements AixAction {
    readonly type = CustomTemplatesActionTypes.LOAD_CUSTOM_TEMPLATE_FAILURE;

    constructor(public payload: ErrorWrapper) {}
}

// Create Custom Templates
export class CreateCustomTemplateAction implements AixAction {
    readonly type = CustomTemplatesActionTypes.CREATE_CUSTOM_TEMPLATE;

    constructor(public payload: CustomTemplateBody) {}
}
export class CreateCustomTemplateSuccessAction implements AixAction {
    readonly type = CustomTemplatesActionTypes.CREATE_CUSTOM_TEMPLATE_SUCCESS;

    constructor(public payload: CustomTemplateCreate) {}
}
export class CreateCustomTemplateFailureAction implements AixAction {
    readonly type = CustomTemplatesActionTypes.CREATE_CUSTOM_TEMPLATE_FAILURE;

    constructor(public payload: ErrorWrapper) {}
}

// Update Custom Templates
export class UpdateCustomTemplateAction implements AixAction {
    readonly type = CustomTemplatesActionTypes.UPDATE_CUSTOM_TEMPLATE;

    constructor(public payload: CustomTemplateBody) {}
}
export class UpdateCustomTemplateSuccessAction implements AixAction {
    readonly type = CustomTemplatesActionTypes.UPDATE_CUSTOM_TEMPLATE_SUCCESS;

    constructor(public payload: CustomTemplateUpdate) {}
}
export class UpdateCustomTemplateFailureAction implements AixAction {
    readonly type = CustomTemplatesActionTypes.UPDATE_CUSTOM_TEMPLATE_FAILURE;

    constructor(public payload: ErrorWrapper) {}
}

// Delete Custom Templates
export class DeleteCustomTemplateAction implements AixAction {
    readonly type = CustomTemplatesActionTypes.DELETE_CUSTOM_TEMPLATE;

    constructor(public payload: number) {}
}
export class DeleteCustomTemplateSuccessAction implements AixAction {
    readonly type = CustomTemplatesActionTypes.DELETE_CUSTOM_TEMPLATE_SUCCESS;

    constructor() {}
}
export class DeleteCustomTemplateFailureAction implements AixAction {
    readonly type = CustomTemplatesActionTypes.DELETE_CUSTOM_TEMPLATE_FAILURE;

    constructor(public payload: ErrorWrapper) {}
}
